/**
 * Observação de um título de credor.
 *
 * Hoje só o pipeline do MEGA a preenche: um título que foi quitado através de
 * um agrupamento é publicado com valor zero, e a nota diz em qual título mãe o
 * valor está. Sem ela o usuário vê R$ 0,00 sem explicação nenhuma, que é pior
 * do que o título não aparecer.
 */
const TitleNote = ({ note, className = "" }) => {
  if (!note) return null;

  return (
    <span className={`title-note text-small color-gray ${className}`.trim()} title={note}>
      {note}
    </span>
  );
};

export default TitleNote;
